import { defineMessages } from 'react-intl';

/* eslint-disable max-len */
export default defineMessages({
  processText: {
    id: 'pages.forgot.confirmation.processText',
    defaultMessage: 'Please wait…',
  },
  successText: {
    id: 'pages.forgot.confirmation.successText',
    defaultMessage: 'Your password has been reset!<br />New password has been sent an email',
  },
  login: {
    id: 'pages.forgot.confirmation.login',
    defaultMessage: 'Click to log in',
  },
});



// WEBPACK FOOTER //
// ./src/pages/ForgotConfirmationPage/messages.js